import { ComponentStore } from '@ngrx/component-store';import { tapResponse } from '@ngrx/operators';

import { Injectable } from "@angular/core";
import { switchMap } from "rxjs/operators";
import { TreeSelectModel } from "@hrra/common-models";
import { SpecializationService } from "../services/specialization.service";
import { IndustryService } from "../services/industry.service";

export interface IndustryTreeSelectState {
    loading: boolean;
    industryTree: TreeSelectModel<string>[];
    overlayVisible: boolean;
}

export const initialState: IndustryTreeSelectState = {
    loading: false,
    industryTree: [],
    overlayVisible: false
}

export interface TreeInputUpdateCommand
{
    newValues: string[];
    existingValues: string[];
    additionalCheckRequired: boolean;
}

@Injectable()
export class IndustryTreeSelectStore extends ComponentStore<IndustryTreeSelectState> {

    constructor(private industryService: IndustryService) {
        super(initialState)
    }

    loading$ = this.select(s => s.loading);
    industryTree$ = this.select(s => s.industryTree);
    overlayVisible$ = this.select(s => s.overlayVisible);

    //updates

    readonly updateLoading = this.updater((state, loading: boolean) => {
        return {
            ...state,
            loading: loading
        }
    });

    readonly updateOverlayVisible = this.updater((state, overlayVisible: boolean) => {
        return {
            ... state,
            overlayVisible: overlayVisible
        }
    });

    readonly updateIndustryTree = this.updater((state, industryTree: TreeSelectModel<string>[]) => {

        return {
            ...state,
            industryTree: industryTree,
            loading: false,
        }
    });

    readonly loadIndustryTree = this.effect((parentId$) => {
        return parentId$.pipe(
            switchMap(() => {
                this.updateLoading(true);
                return this.industryService.getTreeSelectIndustries().pipe(
                    tapResponse({
                        next: (response) => {
                            this.updateIndustryTree(response.data);
                        },
                        error: error => {
                            this.updateLoading(false)
                        }
                    })
                );
            })
        );
    });

}